import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#39b54a'
    }
});

const BalanceButton = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <div style={{ width: '90px' }}>
                <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 201.4 60.6"
                >
                    <g>
                        <path
                            className={classesInline.ColorFill}
                            d="M69.2,27.6c-2.3,0-4.5,1.7-4.5,5s2.2,5.1,4.5,5.1c2.4,0,4.6-1.8,4.6-5.1C73.7,29.4,71.5,27.6,69.2,27.6z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M42.3,27.6c-2.3,0-4.5,1.7-4.5,5s2.2,5.1,4.5,5.1c2.4,0,4.6-1.8,4.6-5.1C46.8,29.4,44.7,27.6,42.3,27.6z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M24.5,31.9h-4.3v5.8h4.4c2.1,0,3.4-1,3.4-2.9C27.9,33,26.6,31.9,24.5,31.9z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M27.4,25.8c0-1.7-1.2-2.7-3.2-2.7h-4v5.4h4C26.2,28.5,27.4,27.6,27.4,25.8z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M124.7,27.4c-2.1,0-3.7,1.3-4.1,3.7h8.2C128.8,28.8,127,27.4,124.7,27.4z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M200,0H1.4C0.6,0,0,0.7,0,1.4v57.7c0,0.8,0.6,1.4,1.4,1.4H200c0.8,0,1.4-0.6,1.4-1.4V1.4
		C201.4,0.7,200.7,0,200,0z M25.2,41.3h-9.3V19.6h8.9c4.5,0,7,2.4,7,5.6c0,2.6-1.6,4.3-3.7,5c2.5,0.4,4.2,2.7,4.2,5.2
		C32.3,38.9,29.7,41.3,25.2,41.3z M51.2,41.3h-4.4v-2.5c-1,1.5-3,2.8-5.7,2.8c-4.3,0-7.8-3.6-7.8-8.9s3.5-8.8,7.9-8.8
		c2.8,0,4.7,1.3,5.7,2.7v-2.5h4.4V41.3z M58.4,41.3h-4.3v-23h4.3V41.3z M78.1,41.3h-4.4v-2.5c-1,1.5-3,2.8-5.7,2.8
		c-4.3,0-7.8-3.6-7.8-8.9s3.5-8.8,7.9-8.8c2.8,0,4.7,1.3,5.7,2.7v-2.5h4.4V41.3z M97.3,41.3H93v-9.5c0-2.8-1.5-4.3-3.8-4.3
		c-2.4,0-3.9,1.5-3.9,4.3v9.5h-4.3V24.1h4.3v2.1c1.1-1.5,3-2.4,5.2-2.4c4,0,6.9,2.6,6.9,7.4V41.3z M107.4,37.8
		c1.8,0,2.9-0.8,3.4-2.4h4.7c-0.9,3.7-3.8,6.1-8.1,6.1c-5,0-8.5-3.5-8.5-8.9c0-5.4,3.5-8.9,8.5-8.9c4.3,0,7.2,2.2,8.1,6.1h-4.7
		c-0.5-1.5-1.6-2.4-3.4-2.4c-2.4,0-4,1.8-4,5.2C103.4,36,105,37.8,107.4,37.8z M133.2,34h-12.6c0.2,2.5,2,4,4.1,4
		c1.9,0,2.9-0.9,3.4-2.1h4.7c-0.9,3.2-3.8,5.7-8,5.7c-5,0-8.6-3.5-8.6-8.9c0-5.4,3.5-8.9,8.6-8.9c5,0,8.5,3.4,8.5,8.5
		C133.3,32.9,133.3,33.4,133.2,34z M166.3,49.2c-10.4,0-18.9-8.5-18.9-18.9s8.5-18.9,18.9-18.9s18.9,8.5,18.9,18.9
		S176.8,49.2,166.3,49.2z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M159,22h5.2c1.9,0,3.5,1.2,4.1,2.9H159v2.9h9.3c-0.6,1.7-2.2,2.9-4.1,2.9H159v2.9l8.6,8.6l2.1-2.1l-6.5-6.5
		h1.1c3.5,0,6.5-2.5,7.2-5.8h2.4v-2.9h-2.4c-0.2-1.1-0.7-2.1-1.3-2.9h3.7v-2.9H159V22z"
                        />
                    </g>
                </svg>
            </div>
        </>
    );
};

export default BalanceButton;
